import jwtAxios from "../../services/axiosInstance/ApiConfig";
import {
	CART_ADD_ITEM,
	CART_REMOVE_ITEM,
	CART_SAVE_SHIPPING_ADDRESS,
	CART_SAVE_PAYMENT_METHOD,
	CART_ADD_ITEM_FAIL,
} from '../../constants/cartConstants';
import { FETCH_START, FETCH_SUCCESS, FETCH_ERROR } from "../types/actions/Common.actions";
import { showErrorMessage } from "../../common/Toaster";

export const addProductToCart = (productId: string, qty: number) =>
	async (dispatch: any, getState: any) => {
	try {
		dispatch({ type: FETCH_START })
		const { data } = await jwtAxios.get(`/products/${productId}`);
		dispatch({ type: FETCH_SUCCESS })
		const {
			cart: { cartItems },
		} = getState();
		if (cartItems.length > 0 && data.seller._id !== cartItems[0].seller._id) {
			dispatch({
				type: CART_ADD_ITEM_FAIL,
				payload: `Can't Add To Cart. Buy only from ${cartItems[0].seller.seller.name} in this order`,
			});
			showErrorMessage(`Can't Add To Cart. Buy only from ${cartItems[0].seller.seller.name} in this order`)
		} else {
			dispatch({
				type: CART_ADD_ITEM,
				payload: {
					name: data.name,
					description: data.description,
					image: data.image,
					brand: data.brand,
					price: data.price,
					countInStock: data.countInStock,
					product: data._id,
					seller: data.seller,
					qty,
				},
			});
		}
	} catch(err: any) {
		dispatch({ type: FETCH_ERROR, error: err })
		showErrorMessage(err)
	}
};

export const removeFromCart = (productId: string) => (dispatch: any, getState: any) => {
	dispatch({ type: CART_REMOVE_ITEM, payload: productId });
};

export const saveShippingAddress = (data: any) => (dispatch: any) => {
	dispatch({ type: CART_SAVE_SHIPPING_ADDRESS, payload: data });
};
export const savePaymentMethod = (data: any) => (dispatch: any) => {
	dispatch({ type: CART_SAVE_PAYMENT_METHOD, payload: data });
};
